export enum BrokerRegistrationConfirmationTypeModel {
  ApprovalRequired,
  AccountCreated
}

export interface BrokerRegistrationConfirmationResult {
  type: BrokerRegistrationConfirmationTypeModel;
}